/** טבעות משולבות — סמל DoWe */
export function RingsIcon({
  className = 'w-9 h-9',
  strokeWidth = 2.25,
}: {
  className?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      viewBox="0 0 48 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <circle cx="17" cy="16" r="12" stroke="currentColor" strokeWidth={strokeWidth} />
      <circle cx="31" cy="16" r="12" stroke="currentColor" strokeWidth={strokeWidth} />
    </svg>
  );
}

type BrandMarkProps = {
  /** dark = טקסט כהה על רקע בהיר · light = לבן על rose · compact = רק אייקון+שם */
  variant?: 'dark' | 'light' | 'compact';
  showTagline?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
};

const sizeMap = {
  sm: { rings: 'w-7 h-5', name: 'text-xl', tag: 'text-[8px]' },
  md: { rings: 'w-9 h-6', name: 'text-2xl', tag: 'text-[9px]' },
  lg: { rings: 'w-12 h-8', name: 'text-3xl', tag: 'text-[10px]' },
};

/**
 * סמל מותג DoWe: טבעות + שם + תגית אופציונלית.
 */
export function BrandMark({
  variant = 'dark',
  showTagline = true,
  className = '',
  size = 'md',
}: BrandMarkProps) {
  const s = sizeMap[size];
  const isLight = variant === 'light';
  const compact = variant === 'compact';

  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <RingsIcon
        className={`${s.rings} shrink-0 ${isLight ? 'text-white' : 'text-sage-600'}`}
      />
      <div className="leading-none">
        <div
          className={`font-display font-bold tracking-tight ${s.name} ${
            isLight ? 'text-white' : 'text-ink'
          }`}
        >
          DoWe
        </div>
        {showTagline && !compact && (
          <div
            className={`mt-1 font-sans font-medium tracking-[0.18em] uppercase ${s.tag} ${
              isLight ? 'text-white/85' : 'text-sage-600'
            }`}
          >
            Wedding Operating System
          </div>
        )}
      </div>
    </div>
  );
}
